import { ReactNode } from 'react'

export interface DetailsColumnProps {
  children: ReactNode
}
export function DetailsColumn({ children }: DetailsColumnProps) {
  return <div className="grid flex-grow grid-cols-4 bg-white">{children}</div>
}
